import { render, staticRenderFns } from "./itemDispatchTable.vue?vue&type=template&id=632b38b8&"
import script from "./itemDispatchTable.vue?vue&type=script&lang=ts&"
export * from "./itemDispatchTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports